// MSAL configuration for Azure AD SSO
// Replace the values below with your Azure AD app registration details

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MS_CLIENT_ID, // TODO: Replace with your Azure AD Application (client) ID
    authority: process.env.REACT_APP_MS_AUTHORITY, // TODO: Replace with your Azure AD tenant ID
    redirectUri: process.env.REACT_APP_REDIRECT_URI, // Or your deployed frontend URL
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};
